import React, { useContext } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  SwipeableDrawer
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

import utils from '../../utils';
import { STARSTAKE_BRANDCLUB_URL, successMsg } from '../../config';
import { MSG } from '../../msg-const';
import MainContext from '../../contexts/MainContext';
import SearchInput from './SearchInput';
// import InstallApp from './InstallApp';

import { ReactComponent as ExpandMoreIcon } from '../../img/svg/Arrows/ArrowHeadDown.svg';
import { ReactComponent as MenuIcon } from '../../img/svg/Menu/Menu.svg';
import { ReactComponent as TraningIcon } from '../../img/svg/Assets/CapBlue.svg';
import { ReactComponent as MintingGuildlinesIcon } from '../../img/svg/Assets/FileBlue.svg';
import { ReactComponent as StarHub } from '../../img/svg/DropDown/StarHub.svg';
import { ReactComponent as MarketHubIcon } from '../../img/svg/Header/MarketHub.svg';
import { ReactComponent as Speaker } from '../../img/svg/Assets/Speaker.svg';
import { ReactComponent as RedeemCertAnftIcon } from '../../img/svg/DropDown/redeem-certificate-anft.svg';
import { ReactComponent as SLetterBlue } from '../../img/svg/Logos/SLetterBlue.svg';
import { ReactComponent as Access } from '../../img/svg/DropDown/Access.svg';
import { ReactComponent as BrandClub } from '../../img/svg/DropDown/BrandClub.svg';
import { ReactComponent as Bucks } from '../../img/svg/DropDown/Bucks.svg';
import { ReactComponent as DiscoverStars } from '../../img/svg/DropDown/DiscoverStars.svg';
import { ReactComponent as Info } from '../../img/svg/DropDown/Info.svg';
import { ReactComponent as Message } from '../../img/svg/DropDown/Message.svg';
import { ReactComponent as Shop } from '../../img/svg/DropDown/shop.svg';
import { ReactComponent as StakeHub } from '../../img/svg/DropDown/StakeHub.svg';
import { ReactComponent as StarSTKR } from '../../img/svg/DropDown/StarSTKR.svg';
import { ReactComponent as CreatorHub } from '../../img/svg/DropDown/CreatorHub.svg';
import { ReactComponent as StakeHubLogo } from '../../img/svg/Logos/StakeHubLogo.svg';
import { ReactComponent as CreatorHubLogo } from '../../img/svg/Logos/CreatorHubLogo.svg';

function MobileMenu({
  walletId = '',
  connect = () => {},
  onCheckPage = () => {},
  onStakehubClick = () => {},
  redirecting = false,
  isRegistered = false,
  hasCreatorAccess = false
}) {
  const context = useContext(MainContext);
  const [creatorhub, setCreatorhub] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const CloseDrawer = () => {
    context.setWalletSlide(true);
    context.setCartSlide(true);
    setOpen(true);
  };

  return (
    <div className="mobile-menu-wrapper">
      <div onClick={() => CloseDrawer()} className="menu-svg-wrapper">
        <MenuIcon />
      </div>
      <SwipeableDrawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        disableSwipeToOpen={false}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          style: {
            background: 'rgba(13, 12, 32, 0.82)',
            backdropFilter: 'blur(11.5px)',
            WebkitBackdropFilter: 'blur(11.5px)',
            maxWidth: '500px',
            width: '75%'
          }
        }}
      >
        <div className="drawer-background">
          <div className="all-link-wrapper">
            <SearchInput />
            {!isRegistered && (
              <>
                <Link
                  to="/ForCreators"
                  className="creator-span mx-auto"
                  onClick={() => setOpen(false)}
                >
                  For Brands
                </Link>
                <Link
                  to="/ForFans"
                  className="fan-span mx-auto"
                  onClick={() => setOpen(false)}
                >
                  For Backers
                </Link>
              </>
            )}
            {data.map((item = {}, index = 0) => (
              <Accordion
                className="link-accordion-wrapper"
                expanded={expanded === index}
                onChange={(_, isExpanded) =>
                  setExpanded(isExpanded ? index : false)
                }
                key={index}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className="text-white"
                >
                  {item.title}
                </AccordionSummary>
                <AccordionDetails
                  className="link-wrapper"
                  onClick={() => setOpen(false)}
                >
                  <div className="menu-header">{item.subtitle}</div>
                  {item.links.map((linkItem = {}) => (
                    <Link
                      key={linkItem.title}
                      to={
                        linkItem.protectedRoute && isRegistered
                          ? linkItem.protectedRoute !== '/CreatorHub' ||
                            hasCreatorAccess
                            ? linkItem.protectedRoute
                            : linkItem.link
                          : linkItem.link
                      }
                      onClick={(e) => {
                        if (linkItem?.externalLink) {
                          e.preventDefault();
                          window.open(linkItem.link);
                        }
                      }}
                    >
                      <div className="single-link-wrapper">
                        {linkItem.icon}
                        <div>
                          <div className="discover-text">{linkItem.title}</div>
                          <div className="description">{linkItem.subtitle}</div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
            {isRegistered && (
              <Nav.Link eventKey="creatorhub">
                <div className="toggle-button" onClick={() => setOpen(false)}>
                  {creatorhub ? (
                    <>
                      <div
                        onMouseEnter={() => setCreatorhub(false)}
                        className="px-3"
                      >
                        <StakeHubLogo />
                      </div>
                      <div onClick={onCheckPage} className="icon-items">
                        <CreatorHubLogo />
                        <span className="creator-span"> CreatorHub</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div onClick={onStakehubClick} className="icon-items">
                        <StakeHubLogo />
                        <span className="fan-span mx-2"> StakeHub</span>
                      </div>
                      <div
                        onMouseEnter={() => !redirecting && setCreatorhub(true)}
                        className="px-3"
                      >
                        <CreatorHubLogo />
                      </div>
                    </>
                  )}
                </div>
              </Nav.Link>
            )}
            {
              isRegistered ? (
                <div
                  className="wallet-account-wrapper"
                  onClick={() => {
                    navigator.clipboard.writeText(walletId);
                    successMsg(MSG['COPY_TO_CLIPBOARD']);
                    setOpen(false);
                  }}
                >
                  <span className="fan-span mx-2">
                    {utils.getShortAccountId(walletId)}
                  </span>
                </div>
              ) : null
              // <div
              //   className="connect-wallet-button mx-auto"
              //   onClick={() => setOpen(false)}
              // >
              //   <Button onClick={() => connect()}>Connect Wallet</Button>
              // </div>
            }
            {/* <InstallApp fromMobile /> */}
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
}

export default MobileMenu;

const data = [
  {
    title: 'Discover',
    subtitle: 'The Real World Funding marketplace',
    links: [
      {
        icon: <MarketHubIcon />,
        title: 'Discover',
        subtitle: 'Discover what’s hot',
        link: '/MarketHub'
      },
      {
        icon: <BrandClub />,
        title: 'Campaign Club',
        subtitle: 'Rewards, status, access & more',
        link: '/MarketHub/BrandClubMarket'
      },
      {
        icon: <Bucks />,
        title: 'RWA Bucks',
        subtitle: 'Currency of the Brands',
        link: '/MarketHub/NFTBucksMarket'
      },
      {
        icon: <Access />,
        title: 'Access Marketplace',
        subtitle: 'Access to goods & services',
        link: '/MarketHub/AccessNFTMarket'
      },
      {
        icon: <DiscoverStars />,
        title: 'Discover Brands',
        subtitle: 'Discover Brands',
        link: '/MarketHub/DiscoverStars'
      }
    ]
  },
  {
    title: 'Explore',
    subtitle: 'DISCOVER Real World Funding',
    links: [
      {
        icon: <CreatorHub />,
        title: 'BrandHub',
        subtitle: 'How RealWorldFunding works for Brands',
        link: '/ForCreators',
        protectedRoute: '/CreatorHub'
      },
      {
        icon: <StakeHub />,
        title: 'StakeHub',
        subtitle: 'How RealWorldFunding works for Backers',
        link: '/ForFans',
        protectedRoute: '/StakeHub'
      },
      // {
      //   icon: <Info />,
      //   title: 'About Us',
      //   subtitle: 'The team behind StarStake',
      //   link: '/AboutUs'
      // },
      // {
      //   icon: <StarSTKR />,
      //   title: '# Real World Funders',
      //   subtitle: 'Our Movement',
      //   link: '/ComingSoon'
      // },
      // {
      //   icon: <SLetterBlue />,
      //   title: 'Real World Campaign Club',
      //   subtitle: 'Join Us',
      //   link: STARSTAKE_BRANDCLUB_URL,
      //   externalLink: true
      // },
      // {
      //   icon: <Shop />,
      //   title: 'Shop',
      //   subtitle: 'Check out our merch',
      //   link: '/ComingSoon'
      // }
    ]
  },
  {
    title: 'Resources',
    subtitle: 'GET WHAT YOU NEED',
    links: [
      {
        icon: <Message />,
        title: 'Help Center',
        subtitle: "We're here to help",
        link: 'https://intercom.help/starstake',
        externalLink: true
      },
      {
        title: 'Redeem Access Certificate',
        description: 'Enter your access code here',
        icon: <RedeemCertAnftIcon />,
        link: '/ForFans',
        protectedRoute: '/StakeHub/AccessNFT?redeem=true'
      },
      {
        icon: <MintingGuildlinesIcon />,
        title: 'Community Guidelines',
        subtitle: 'Our backer / brand guidelines',
        link: '/StarStakeGuidelines'
      },
      // {
      //   icon: <Speaker />,
      //   title: 'Latest News',
      //   subtitle: 'What’s going on',
      //   link: 'https://www.instagram.com/star_stake/',
      //   externalLink: true
      // },
      // {
      //   icon: <TraningIcon />,
      //   title: 'Training Center',
      //   subtitle: 'Learn how to use StarStake',
      //   link: '/ForFans',
      //   protectedRoute: '/StakeHub/TrainingCenter'
      // },
      // {
      //   icon: <StarHub />,
      //   title: 'Community',
      //   subtitle: 'Join us on StarHub',
      //   link: 'https://starhub.starstake.com/',
      //   externalLink: true
      // }
    ]
  }
];
